//@flow
import React from 'react';
import {makeStyles, TableCell, TableRow} from '@material-ui/core';

import {useTableCells} from '../../context/CellContext';

const useStyles = makeStyles(theme => ({
  headerCell: {
    whiteSpace: 'nowrap',
    fontWeight: 600,
    padding: '0 1rem',
    height: '48px',
    '&:nth-of-type(odd)': {
      background: '#D4D4DD66',
    },
  },
  headerCellContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    justifyContent: 'space-between',
  },

  ghostCell: {
    background: 'transparent',
    width: '10rem',
  },
}));

export default function TableHeader() {
  const classes = useStyles();

  const activeCells = useTableCells();

  return (
    <TableRow>
      <TableCell />
      <TableCell />
      {activeCells.map(({id, HeaderLeftAdornment, Header}) => (
        <TableCell key={id} className={classes.headerCell}>
          <div className={classes.headerCellContent}>
            {typeof Header === 'string' ? Header : <Header />}
            {HeaderLeftAdornment && <HeaderLeftAdornment />}
          </div>
        </TableCell>
      ))}
      {activeCells.length < 7 &&
        new Array(7 - activeCells.length)
          .fill(0)
          .map((_, index) => (
            <TableCell key={index} className={classes.ghostCell}></TableCell>
          ))}
    </TableRow>
  );
}
